import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import BlockActions from './BlockActions';
import EditableBlock from './EditableBlock';
import '../styles/SortableItem.css';

const SortableItem = ({ block, isEditing, onBlockUpdated, onBlockDeleted }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: block.id });

  const style = transform ? {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 999 : 'auto',
    position: isDragging ? 'relative' : undefined,
    opacity: isDragging ? 0.5 : 1,
  } : undefined;

  return (
    <div 
      ref={setNodeRef}
      style={style}
      className={`block-wrapper ${isEditing ? 'editing' : ''} ${isDragging ? 'dragging' : ''}`}
    >
      {isEditing && (
        <>
          <div className="drag-handle" {...attributes} {...listeners}>
            <span>≡</span>
          </div>
          <BlockActions 
            block={block} 
            onBlockUpdated={onBlockUpdated} 
            onBlockDeleted={onBlockDeleted}
          />
        </>
      )}
      
      {isEditing ? (
        <EditableBlock
          block={block}
          onBlockUpdated={onBlockUpdated}
        />
      ) : (
        <div className="block-content">
          <EditableBlock
            block={block}
            onBlockUpdated={onBlockUpdated}
          />
        </div>
      )}
    </div>
  );
};

export default SortableItem;